import { baseApi } from 'core/api/base'
import { IFeedbackBody, IFeedbackResponse } from 'core/interfaces/Feedback'

const FEEDBACK_ENDPOINT = '/feedback'

const feedbackApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    postFeedback: builder.mutation<IFeedbackResponse, IFeedbackBody>({
      query: (feedback) => ({
        url: FEEDBACK_ENDPOINT,
        method: 'POST',
        body: feedback,
      }),
      invalidatesTags: [],
    }),
  }),
})

export const { usePostFeedbackMutation } = feedbackApi
